__turbopack_context__.v({
  "acheivername": "psy-optional-module__TOC6IG__acheivername",
  "acheivername1": "psy-optional-module__TOC6IG__acheivername1",
  "acheiverrank": "psy-optional-module__TOC6IG__acheiverrank",
  "acheiverrank1": "psy-optional-module__TOC6IG__acheiverrank1",
  "acheiverrank2": "psy-optional-module__TOC6IG__acheiverrank2",
  "acheiverrank3": "psy-optional-module__TOC6IG__acheiverrank3",
  "acheiverrank4": "psy-optional-module__TOC6IG__acheiverrank4",
  "acheivertitle": "psy-optional-module__TOC6IG__acheivertitle",
  "ansheet": "psy-optional-module__TOC6IG__ansheet",
  "bgboxbg": "psy-optional-module__TOC6IG__bgboxbg",
  "captcha": "psy-optional-module__TOC6IG__captcha",
  "checkboxcontent": "psy-optional-module__TOC6IG__checkboxcontent",
  "classesborder": "psy-optional-module__TOC6IG__classesborder",
  "contactbox": "psy-optional-module__TOC6IG__contactbox",
  "contactboxheight": "psy-optional-module__TOC6IG__contactboxheight",
  "contactsubcontent": "psy-optional-module__TOC6IG__contactsubcontent",
  "gshad": "psy-optional-module__TOC6IG__gshad",
  "img": "psy-optional-module__TOC6IG__img",
  "imgboxbelow": "psy-optional-module__TOC6IG__imgboxbelow",
  "invalidCheck2": "psy-optional-module__TOC6IG__invalidCheck2",
  "mainshead": "psy-optional-module__TOC6IG__mainshead",
  "mbtableheading": "psy-optional-module__TOC6IG__mbtableheading",
  "medalicon": "psy-optional-module__TOC6IG__medalicon",
  "mobhead": "psy-optional-module__TOC6IG__mobhead",
  "mobilemaillinks": "psy-optional-module__TOC6IG__mobilemaillinks",
  "more": "psy-optional-module__TOC6IG__more",
  "normalbutton": "psy-optional-module__TOC6IG__normalbutton",
  "normalbutton2": "psy-optional-module__TOC6IG__normalbutton2",
  "pagemaintitle": "psy-optional-module__TOC6IG__pagemaintitle",
  "paybill": "psy-optional-module__TOC6IG__paybill",
  "paybills": "psy-optional-module__TOC6IG__paybills",
  "redunderline": "psy-optional-module__TOC6IG__redunderline",
  "sectiontitle": "psy-optional-module__TOC6IG__sectiontitle",
  "sectiontitle1": "psy-optional-module__TOC6IG__sectiontitle1",
  "sectiontitle2": "psy-optional-module__TOC6IG__sectiontitle2",
  "subhead": "psy-optional-module__TOC6IG__subhead",
  "tableheading": "psy-optional-module__TOC6IG__tableheading",
  "tablepara": "psy-optional-module__TOC6IG__tablepara",
  "tablepara1": "psy-optional-module__TOC6IG__tablepara1",
  "tablescroll": "psy-optional-module__TOC6IG__tablescroll",
  "toppersupsc": "psy-optional-module__TOC6IG__toppersupsc",
  "viewbutton": "psy-optional-module__TOC6IG__viewbutton",
});
